/**
 * Zero schema and query builder.
 *
 * Separated from index.ts to break circular imports.
 * Mutators and queries import zql from here, not from index.ts.
 */

import { createBuilder, createSchema } from "@rocicorp/zero";

import { allTables } from "./tables/all-tables";

import "./default-types";

export const schema = createSchema({
  tables: allTables,
  relationships: [],
});

export type Schema = typeof schema;

export const zql = createBuilder(schema);
